import React from "react";
import PropTypes from "prop-types";
import Moment from "moment";
import { useSelector } from "react-redux";
import { translateTimezone } from "@qgiv/core-js";
import { ChipContent } from "@qgiv/core-react";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";

const ConnectedEarlyRegistrationChipContent = ({ categoryId }) => {
    const categories = useSelector(selectAllCategories);
    const category = categories.find(
        (_category) => _category.id === categoryId,
    );
    const { earlyRegistrationDate, feeTitle } = category;
    const { timezone = "" } = useSelector(selectAllP2pSettings);

    // Infer props from settings
    const momentEarlyRegistrationDate = Moment(earlyRegistrationDate);
    const formattedEarlyRegistrationDate = momentEarlyRegistrationDate.isValid()
        ? momentEarlyRegistrationDate.format("M.D.YYYY h:mma z")
        : "";

    const label = `${feeTitle} ends on ${formattedEarlyRegistrationDate} ${translateTimezone(
        timezone,
    )}`;

    const glyph = "usd-circle-solid";

    const chipContentProps = {
        label,
        glyph,
    };
    return <ChipContent {...chipContentProps} />;
};

ConnectedEarlyRegistrationChipContent.propTypes = {
    categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
};

export default ConnectedEarlyRegistrationChipContent;
